jQuery(document).ready(function ($) {
  const galleries = document.querySelectorAll(`.lightbox-gallery`);

  if (galleries) {
    galleries.forEach(function (gallery) {
      const images = gallery.querySelectorAll('.wp-block-image a');

      if (images) {
        images.forEach(function (imageLink) {
          imageLink.dataset.fancybox = 'gallery';
        });
      }
    });
    //test if FancyBox is loaded

    if (typeof Fancybox !== 'undefined') Fancybox.bind('[data-fancybox]', {});
  }
});
